import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltySendVerificationEmail',
  initialState: true,
  reducers: {
    setLoyaltySendVerificationEmail(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltySendVerificationEmail } = slice.actions;

export default slice.reducer;
